import Axios from 'axios';

const getEmailSignatures = async (listingId: string) => {
  const { data } = await Axios.get(
    `/listing/${listingId}/template/rep_signature`,
  );
  return data;
};
export default getEmailSignatures;
